import { instance } from 'api/api';
import { APIResponse } from 'tools/types';
import { ColumnData, DatasetData, DatasetInstance } from 'components/dataset-viewer';
import { YNValues } from 'tools/types';

const REPORT_ALERT_RULE_BASE_URL = `/data/report-alert-rule/`;

export interface ReportAlertRuleData {
    report_alert_rule_id: number;
    name: string;
    rules_serialized: string;
    element_id: number;
    rule_display_template: string;
    report_id: number;
}

export interface ReportData {
    report_id: number;
    element_id: number;
    name: string;
    dataset_id: number;
    dataset_filter_id: number;
}

export interface AlertRuleListItem {
    report_alert_rule_id: number;
    name: string;
}

export interface ReportAlertRuleDataResponse {
    alertRuleData: ReportAlertRuleData;
    reportData: ReportData;
    columnsData: ColumnData[];
    datasetData: DatasetData;
    datasetInstances: DatasetInstance[];
    updateFormattedDate: string;
    allAlertRules: AlertRuleListItem[];
    isAdmin: YNValues;
    isPermitted4Edit: YNValues;
    userId: string;
}

export interface InstancesDataResponse {
    datasetInstances: DatasetInstance[];
    withHistory: boolean;
}

export const reportAlertRuleAPI = {
    async getReportAlertRuleData(
        elementId: number,
        reportAlertRuleId: number,
    ): Promise<APIResponse<ReportAlertRuleDataResponse>> {
        const url = REPORT_ALERT_RULE_BASE_URL + `${elementId}/alert-rule/${reportAlertRuleId}/load-data`;
        const response = await instance.get(url);

        return response.data;
    },

    async saveAlertRule(
        elementId: number,
        reportAlertRuleId: number,
        serializedRule: string,
        ruleDisplayTemplate: string,
        ruleName?: string,
    ): Promise<APIResponse<{}>> {
        const url = REPORT_ALERT_RULE_BASE_URL + `${elementId}/alert-rule/${reportAlertRuleId}/save`;
        const data: any = {
            rules_serialized: serializedRule,
            rule_display_template: ruleDisplayTemplate,
        };
        if (ruleName) {
            data['rule_name'] = ruleName;
        }
        const response = await instance.post(url, data);

        return response.data;
    },

    async getInstancesData(elementId: number): Promise<APIResponse<InstancesDataResponse>> {
        const url = REPORT_ALERT_RULE_BASE_URL + `${elementId}/get-instances`;
        const response = await instance.get(url);
        return response.data;
    },

    async generateAlertEvents(
        elementId: number,
        alertRuleId?: number,
        dateFrom?: string,
        dateTo?: string,
    ): Promise<APIResponse<{}>> {
        const url =
            REPORT_ALERT_RULE_BASE_URL +
            `${elementId}` +
            (alertRuleId && alertRuleId > 0 ? '/alert-rule/' + alertRuleId : '') +
            `/generate-events`;
        const response = await instance.post(url, { date_from: dateFrom ?? null, date_to: dateTo ?? null });
        return response.data;
    },
};
